import { useStyles, Container } from './style';

import logo from 'assets/img/logo.svg';

const MenuLayout: React.FC<{}> = (props) => {
  const classes = useStyles();

  return (
    <Container>
      <div className={classes.wrapper}>
        <img src={logo} alt="Oma PREMIS" className={classes.logo} />
        {props.children}
        <p className={classes.copy}>
          {`Pre-Ohjelmistot Oy © 2017 - ${new Date().getFullYear()}`}
        </p>
      </div>
    </Container>
  );
};

export default MenuLayout;
